// extracted by mini-css-extract-plugin
module.exports = {"root":"PartnerList_root__qt88f","logo":"PartnerList_logo__3Z3eC","heading":"PartnerList_heading__1-bFS"};